import { Button, colors, typography } from '@insurancemenu/imenu-components-lib';
import styled, { CSSProp } from 'styled-components';
import { breakpointsMQ4 } from '@insurancemenu/imenu-components-lib/dist/utils/breakpoints';

export const CancelButtonStyled = styled(Button)`
  margin-top: 2.7rem;
  min-width: unset;
  width: 4.4rem;
  height: 4.4rem;
  margin-right: auto;
`;

export const EmployerWrapperStyled = styled.div<{ $isGroupAdmin: boolean }>`
  display: grid;
  grid-template-columns: 1fr 11rem;
  column-gap: 2rem;
  align-items: center;
  border-radius: 0.6rem;
  background-color: ${({ $isGroupAdmin }): CSSProp => ($isGroupAdmin ? colors.blue[100] : colors.neutral[100])};
  border: ${({ $isGroupAdmin }): CSSProp => ($isGroupAdmin ? `0.2rem solid ${colors.blue[600]}` : 'none')};
  padding: 2.4rem 4rem;

  &:not(:last-child) {
    margin-bottom: 3rem;
  }
`;

export const EmployerBlockStyled = styled.div`
  display: grid;
  grid-template-columns: 1fr 1.5fr 1fr 1fr 1.5fr;
  gap: 4rem 2%;
  ${breakpointsMQ4.sm.down} {
    grid-template-columns: repeat(auto-fit, minmax(12rem, 1fr));
  }
`;

export const ReinviteButtonStyled = styled(Button)`
  padding: 0;
`;

export const EmployerBlockKeyStyled = styled.p`
  text-transform: uppercase;
  color: ${colors.neutral[500]};
  ${typography.bold[14]}
`;

export const EmployerBlockValueStyled = styled.p`
  ${typography.regular[16]}
  margin: 0;
  word-break: break-word;
  color: ${colors.neutral[800]};
`;

export const StatusValueStyled = styled.span`
  ${typography.bold[14]}
  color: ${colors.neutral[800]};
  margin-left: 1rem;
`;

export const GroupAdminTagStyled = styled.p`
  ${typography.bold[14]}
  color: ${colors.blue[600]};
  padding-left: 0.6rem;
  text-transform: uppercase;
`;

export const ActionBtnStyled = styled(Button)`
  text-transform: uppercase;
  padding: 0;
`;

export const EditBtnStyled = styled(ActionBtnStyled)`
  margin-bottom: 2rem;
`;
